export const Home = "home";
export const ToHome =  { name: Home };
export const Security = "Security";
export const DrivewealthInvestmentActivity = "DrivewealthInvestmentActivity";
export const DrivewealthInvestmentActivityV2 = "DrivewealthInvestmentActivityV2";
export const DrivewealthInvestmentActivityTransfers = "DrivewealthInvestmentActivityTransfers";
export const DrivewealthInvestmentActivityTransfersV2 = "DrivewealthInvestmentActivityTransfersV2";
export const DrivewealthInvestmentActivityHistory = "DrivewealthInvestmentActivityHistory";
export const DrivewealthInvestmentActivityHistoryV2 = "DrivewealthInvestmentActivityHistoryV2";
export const DrivewealthInvestmentAccount = "DrivewealthInvestmentAccount";
export const DrivewealthAccountLiquidation = "DrivewealthAccountLiquidation";
export const DrivewealthInvestmentAccountV2 = "DrivewealthInvestmentAccountV2";
export const DrivewealthInvestmentDocuments = "DrivewealthInvestmentDocuments";
export const DrivewealthInvestmentDocumentsV2 = "DrivewealthInvestmentDocumentsV2";
export const DrivewealthInvestmentDayTrades = "DrivewealthInvestmentDayTrades";
export const DrivewealthInvestmentDayTradesV2 = "DrivewealthInvestmentDayTradesV2";
export const DrivewealthHsabAccountSignature = "DrivewealthHsabAccountSignature";
export const DrivewealthInvestmentFeesV2 = "DrivewealthInvestmentFeesV2";
export const DrivewealthInvestmentAccountList = "DrivewealthInvestmentAccountList";
export const DrivewealthClosedAccountList = "DrivewealthAvailableInvestments";
export const DrivewealthAvailableInvestments = "DrivewealthAvailableInvestments";
export const DrivewealthAvailableInvestmentsV2 = "DrivewealthAvailableInvestmentsV2";
export const DrivewealthCurrentHoldings = "DrivewealthCurrentHoldings";
export const DrivewealthAccountSummary = "DrivewealthAccountSummary";
export const InstrumentPerformance = "InstrumentPerformance";